module.exports = __webpack_public_path__ + "img/es-back.8b1603a9.png";